export default __webpack_public_path__ + "static/media/upak.3d166e3a.svg";